import { InjectionToken } from '@angular/core';

export interface UnavailableModalConfig {
  translationKeyPrefix: string;
  redirectUrl?: string;
}

export const UNAVAILABLE_MODAL_CONFIG = new InjectionToken<UnavailableModalConfig>(
  'UnavailableModalConfig',
);
